export const SITE_URL = 'https://jotunheims.com';
export const ORG_REF = { '@id': `${SITE_URL}/#organization` };

export const breadcrumbLd = (items) => ({
  '@type': 'BreadcrumbList',
  itemListElement: items.map((item, i) => ({
    '@type': 'ListItem',
    position: i + 1,
    name: item.label,
    item: `${SITE_URL}${item.to}`
  }))
});

export const faqLd = (faqs) => ({
  '@type': 'FAQPage',
  mainEntity: faqs.map((f) => ({
    '@type': 'Question',
    name: f.question,
    acceptedAnswer: { '@type': 'Answer', text: f.answer }
  }))
});

export const isFounder = (post) => post.author_name === 'Nelson M. Acevedo';
export const authorLabel = (post) => (isFounder(post) ? 'Nelson M. Acevedo, Founder & CEO' : 'Jotunheims Team');